// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   CHAT PANEL
   ========================================================================== */

.chat-panel {
    position: fixed;
    bottom: 0;
    right: 24px;
    z-index: 1300;

    width: 380px;
    height: 80vh;

    background: white;
    border-radius: 16px 16px 0 0;

    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);

    border: 1px solid #e5e7eb;
    border-bottom: none;

    display: flex;
    flex-direction: column;

    overflow: hidden;

    animation: slide-up 0.35s cubic-bezier(0.4, 0, 0.2, 1);

    transition:
        width 0.25s ease,
        height 0.25s ease;
}

/* Expand panel when conversation sidebar is visible */
.chat-panel.sidebar-open {
    width: 650px;
    max-width: calc(100vw - 32px);
}

.chat-panel.minimized {
    height: auto;
}

/* ==========================================================================
   HEADER
   ========================================================================== */

.chat-header {
    padding: 12px 16px;
    background: linear-gradient(135deg, #3B82F6, #2563EB);
    color: white;
    border-radius: 16px 16px 0 0;
    flex-shrink: 0;
}

.header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.assistant-info {
    display: flex;
    align-items: center;
    gap: 10px;
}

.assistant-avatar {
    width: 32px;
    height: 32px;

    background: rgba(255, 255, 255, 0.2);

    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;
}

.sparkles-icon {
    width: 16px;
    height: 16px;
    color: white;
}

.assistant-text h3 {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    line-height: 1.2;
}

.assistant-text p {
    font-size: 11px;
    opacity: 0.8;
    margin: 0;
    line-height: 1.2;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 4px;
}

.reduce-button,
.close-button,
.conversations-button,
.new-conversation-button {
    background: none;
    border: none;
    color: white;
    cursor: pointer;

    padding: 4px;

    border-radius: 4px;

    display: flex;
    align-items: center;
    justify-content: center;

    line-height: 0;

    transition: background-color 0.2s;
}

.reduce-button:hover,
.close-button:hover,
.conversations-button:hover,
.new-conversation-button:hover {
    background: rgba(255, 255, 255, 0.2);
}

.chat-panel.sidebar-open .conversations-button {
    background: rgba(255, 255, 255, 0.2);
}

/* ==========================================================================
   BODY
   ========================================================================== */

.chat-body {
    display: flex;
    flex: 1 1;

    min-height: 0;
    overflow: hidden;
}

/* ==========================================================================
   CONVERSATIONS SIDEBAR
   ========================================================================== */

.conversations-sidebar {
    width: 0;
    min-width: 0;

    overflow: hidden;

    background: #f8f9fa;
    border-right: 1px solid rgba(0, 0, 0, 0.08);

    display: flex;
    flex-direction: column;

    flex-shrink: 0;

    transition:
        width 0.25s cubic-bezier(0.4, 0, 0.2, 1),
        min-width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.chat-panel.sidebar-open .conversations-sidebar {
    width: 220px;
    min-width: 220px;
}

.sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 10px;

    font-size: 11px;
    font-weight: 600;
    color: #555;

    border-bottom: 1px solid rgba(0, 0, 0, 0.07);

    flex-shrink: 0;
}

.new-conv-sidebar-button {
    font-size: 10px;

    padding: 2px 7px;

    border-radius: 4px;

    border: 1px solid #3B82F6;

    background: transparent;
    color: #3B82F6;

    cursor: pointer;

    transition: background 0.15s, color 0.15s;
}

.new-conv-sidebar-button:hover {
    background: #3B82F6;
    color: white;
}

.sidebar-loading,
.sidebar-empty {
    padding: 16px 10px;
    font-size: 11px;
    color: #999;
    text-align: center;
}

.conversations-list {
    list-style: none;
    margin: 0;
    padding: 4px 0;

    overflow-y: auto;
    flex: 1 1;

    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
}

.conversations-list::-webkit-scrollbar {
    width: 3px;
}

.conversations-list::-webkit-scrollbar-track {
    background: transparent;
}

.conversations-list::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 2px;
}

.conversation-item {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 7px 10px;

    cursor: pointer;

    border-radius: 6px;
    margin: 2px 4px;

    font-size: 11px;
    color: #444;

    transition: background 0.15s;
}

.conversation-item:hover {
    background: rgba(0, 0, 0, 0.05);
}

.conversation-item.active {
    background: rgba(59, 130, 246, 0.1);
    color: #2563EB;
    font-weight: 600;
}

.conv-title {
    flex: 1 1;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    margin-right: 4px;
}

.conv-actions {
    display: flex;
    align-items: center;
    gap: 2px;

    opacity: 0;
    pointer-events: none;

    transition: opacity 0.15s;
}

.conversation-item:hover .conv-actions,
.conversation-item.active .conv-actions {
    opacity: 1;
    pointer-events: auto;
}

.conv-rename-button,
.conv-delete-button {
    background: transparent;
    border: none;

    cursor: pointer;

    padding: 2px;

    color: #bbb;

    display: flex;
    align-items: center;

    border-radius: 3px;

    transition: color 0.15s;
}

.conv-rename-button:hover {
    color: #3B82F6;
}

.conv-delete-button:hover {
    color: #ef4444;
}

.conv-rename-input {
    flex: 1 1;

    min-width: 0;

    font-size: 11px;

    padding: 2px 5px;

    border: 1px solid #3B82F6;
    border-radius: 3px;

    outline: none;

    background: white;

    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}

/* ==========================================================================
   MAIN CHAT COLUMN
   ========================================================================== */

.chat-main {
    display: flex;
    flex-direction: column;

    flex: 1 1;
    min-width: 0;

    overflow: hidden;
}

/* ==========================================================================
   MESSAGES
   ========================================================================== */

.messages-area {
    flex: 1 1;

    min-height: 0;

    padding: 16px;

    overflow-y: auto;

    background: linear-gradient(180deg, #ffffff, #f9fafb);

    display: flex;
    flex-direction: column;

    gap: 12px;
}

.messages-area::-webkit-scrollbar {
    width: 4px;
}

.messages-area::-webkit-scrollbar-track {
    background: transparent;
}

.messages-area::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 2px;
}

/* ==========================================================================
   WELCOME MESSAGE
   ========================================================================== */

.welcome-message {
    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: center;

    flex: 1 1;

    padding: 32px 16px;

    text-align: center;
}

.welcome-icon {
    width: 48px;
    height: 48px;

    background: rgba(59, 130, 246, 0.1);

    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-bottom: 12px;
}

.welcome-icon svg {
    width: 24px;
    height: 24px;
    color: #3B82F6;
}

.welcome-message p {
    color: #6b7280;
    font-size: 14px;
    margin: 0;
}

/* ==========================================================================
   INPUT
   ========================================================================== */

.chat-input-area {
    padding: 12px 16px;

    border-top: 1px solid #e5e7eb;

    background: white;

    flex-shrink: 0;
}

.input-container {
    display: flex;
    align-items: center;

    gap: 8px;
    width: 100%;
}

.message-input {
    flex: 1 1;
    min-width: 0;

    padding: 10px 14px;

    border: 1px solid #d1d5db;
    border-radius: 8px;

    font-size: 14px;
    font-family: inherit;

    outline: none;

    transition: border-color 0.2s;

    resize: none;
}

.message-input:focus {
    border-color: #3B82F6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.message-input:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #f9fafb;
}

.send-button {
    background: #3B82F6;
    color: white;

    border: none;
    border-radius: 8px;

    padding: 10px 12px;

    cursor: pointer;

    flex-shrink: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    transition:
        background-color 0.2s,
        transform 0.1s;
}

.send-button:hover:not(:disabled) {
    background: #2563EB;
}

.send-button:active:not(:disabled) {
    transform: scale(0.95);
}

.send-button:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.send-button svg {
    width: 16px;
    height: 16px;
}

/* ==========================================================================
   ANIMATIONS
   ========================================================================== */

@keyframes slide-up {
    from {
        transform: translateY(100%);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

/* ==========================================================================
   MOBILE
   ========================================================================== */

@media (max-width: 768px) {

    .chat-panel {
        right: 0;
        bottom: 0;

        width: 100vw;
        height: 100vh;

        border-radius: 0;
    }

    .chat-panel.sidebar-open {
        width: 100vw;
    }

    .chat-panel.sidebar-open .conversations-sidebar {
        width: 180px;
        min-width: 180px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/ChatPanel.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa;;IAEb,YAAY;IACZ,YAAY;;IAEZ,iBAAiB;IACjB,4BAA4B;;IAE5B,iDAAiD;;IAEjD,yBAAyB;IACzB,mBAAmB;;IAEnB,aAAa;IACb,sBAAsB;;IAEtB,gBAAgB;;IAEhB,sDAAsD;;IAEtD;;yBAEqB;AACzB;;AAEA,sDAAsD;AACtD;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;;+EAE+E;;AAE/E;IACI,kBAAkB;IAClB,qDAAqD;IACrD,YAAY;IACZ,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,oCAAoC;;IAEpC,kBAAkB;;IAElB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;;;;IAII,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;;IAEf,YAAY;;IAEZ,kBAAkB;;IAElB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,cAAc;;IAEd,iCAAiC;AACrC;;AAEA;;;;IAII,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;+EAE+E;;AAE/E;IACI,aAAa;IACb,SAAO;;IAEP,aAAa;IACb,gBAAgB;AACpB;;AAEA;;+EAE+E;;AAE/E;IACI,QAAQ;IACR,YAAY;;IAEZ,gBAAgB;;IAEhB,mBAAmB;IACnB,2CAA2C;;IAE3C,aAAa;IACb,sBAAsB;;IAEtB,cAAc;;IAEd;;oDAEgD;AACpD;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,aAAa;;IAEb,eAAe;IACf,gBAAgB;IAChB,WAAW;;IAEX,4CAA4C;;IAE5C,cAAc;AAClB;;AAEA;IACI,eAAe;;IAEf,gBAAgB;;IAEhB,kBAAkB;;IAElB,yBAAyB;;IAEzB,uBAAuB;IACvB,cAAc;;IAEd,eAAe;;IAEf,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,cAAc;;IAEd,gBAAgB;IAChB,SAAO;;IAEP,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,iBAAiB;;IAEjB,eAAe;;IAEf,kBAAkB;IAClB,eAAe;;IAEf,eAAe;IACf,WAAW;;IAEX,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAO;;IAEP,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;;IAEnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;;IAER,UAAU;IACV,oBAAoB;;IAEpB,yBAAyB;AAC7B;;AAEA;;IAEI,UAAU;IACV,oBAAoB;AACxB;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;;IAEZ,eAAe;;IAEf,YAAY;;IAEZ,WAAW;;IAEX,aAAa;IACb,mBAAmB;;IAEnB,kBAAkB;;IAElB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;;IAEP,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,yBAAyB;IACzB,kBAAkB;;IAElB,aAAa;;IAEb,iBAAiB;;IAEjB,8CAA8C;AAClD;;AAEA;;+EAE+E;;AAE/E;IACI,aAAa;IACb,sBAAsB;;IAEtB,SAAO;IACP,YAAY;;IAEZ,gBAAgB;AACpB;;AAEA;;+EAE+E;;AAE/E;IACI,SAAO;;IAEP,aAAa;;IAEb,aAAa;;IAEb,gBAAgB;;IAEhB,qDAAqD;;IAErD,aAAa;IACb,sBAAsB;;IAEtB,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;+EAE+E;;AAE/E;IACI,aAAa;IACb,sBAAsB;;IAEtB,mBAAmB;IACnB,uBAAuB;;IAEvB,SAAO;;IAEP,kBAAkB;;IAElB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,mCAAmC;;IAEnC,kBAAkB;;IAElB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA;;+EAE+E;;AAE/E;IACI,kBAAkB;;IAElB,6BAA6B;;IAE7B,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;;IAEnB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,SAAO;IACP,YAAY;;IAEZ,kBAAkB;;IAElB,yBAAyB;IACzB,kBAAkB;;IAElB,eAAe;IACf,oBAAoB;;IAEpB,aAAa;;IAEb,6BAA6B;;IAE7B,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;;IAEZ,YAAY;IACZ,kBAAkB;;IAElB,kBAAkB;;IAElB,eAAe;;IAEf,cAAc;;IAEd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB;;sBAEkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;+EAE+E;;AAE/E;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;;+EAE+E;;AAE/E;;IAEI;QACI,QAAQ;QACR,SAAS;;QAET,YAAY;QACZ,aAAa;;QAEb,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;AACJ","sourcesContent":["/* ==========================================================================\r\n   CHAT PANEL\r\n   ========================================================================== */\r\n\r\n.chat-panel {\r\n    position: fixed;\r\n    bottom: 0;\r\n    right: 24px;\r\n    z-index: 1300;\r\n\r\n    width: 380px;\r\n    height: 80vh;\r\n\r\n    background: white;\r\n    border-radius: 16px 16px 0 0;\r\n\r\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\r\n\r\n    border: 1px solid #e5e7eb;\r\n    border-bottom: none;\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    overflow: hidden;\r\n\r\n    animation: slide-up 0.35s cubic-bezier(0.4, 0, 0.2, 1);\r\n\r\n    transition:\r\n        width 0.25s ease,\r\n        height 0.25s ease;\r\n}\r\n\r\n/* Expand panel when conversation sidebar is visible */\r\n.chat-panel.sidebar-open {\r\n    width: 650px;\r\n    max-width: calc(100vw - 32px);\r\n}\r\n\r\n.chat-panel.minimized {\r\n    height: auto;\r\n}\r\n\r\n/* ==========================================================================\r\n   HEADER\r\n   ========================================================================== */\r\n\r\n.chat-header {\r\n    padding: 12px 16px;\r\n    background: linear-gradient(135deg, #3B82F6, #2563EB);\r\n    color: white;\r\n    border-radius: 16px 16px 0 0;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.header-content {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.assistant-info {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.assistant-avatar {\r\n    width: 32px;\r\n    height: 32px;\r\n\r\n    background: rgba(255, 255, 255, 0.2);\r\n\r\n    border-radius: 50%;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    flex-shrink: 0;\r\n}\r\n\r\n.sparkles-icon {\r\n    width: 16px;\r\n    height: 16px;\r\n    color: white;\r\n}\r\n\r\n.assistant-text h3 {\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    margin: 0;\r\n    line-height: 1.2;\r\n}\r\n\r\n.assistant-text p {\r\n    font-size: 11px;\r\n    opacity: 0.8;\r\n    margin: 0;\r\n    line-height: 1.2;\r\n}\r\n\r\n.header-actions {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n}\r\n\r\n.reduce-button,\r\n.close-button,\r\n.conversations-button,\r\n.new-conversation-button {\r\n    background: none;\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n\r\n    padding: 4px;\r\n\r\n    border-radius: 4px;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    line-height: 0;\r\n\r\n    transition: background-color 0.2s;\r\n}\r\n\r\n.reduce-button:hover,\r\n.close-button:hover,\r\n.conversations-button:hover,\r\n.new-conversation-button:hover {\r\n    background: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.chat-panel.sidebar-open .conversations-button {\r\n    background: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n/* ==========================================================================\r\n   BODY\r\n   ========================================================================== */\r\n\r\n.chat-body {\r\n    display: flex;\r\n    flex: 1;\r\n\r\n    min-height: 0;\r\n    overflow: hidden;\r\n}\r\n\r\n/* ==========================================================================\r\n   CONVERSATIONS SIDEBAR\r\n   ========================================================================== */\r\n\r\n.conversations-sidebar {\r\n    width: 0;\r\n    min-width: 0;\r\n\r\n    overflow: hidden;\r\n\r\n    background: #f8f9fa;\r\n    border-right: 1px solid rgba(0, 0, 0, 0.08);\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    flex-shrink: 0;\r\n\r\n    transition:\r\n        width 0.25s cubic-bezier(0.4, 0, 0.2, 1),\r\n        min-width 0.25s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.chat-panel.sidebar-open .conversations-sidebar {\r\n    width: 220px;\r\n    min-width: 220px;\r\n}\r\n\r\n.sidebar-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n\r\n    padding: 10px;\r\n\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    color: #555;\r\n\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.07);\r\n\r\n    flex-shrink: 0;\r\n}\r\n\r\n.new-conv-sidebar-button {\r\n    font-size: 10px;\r\n\r\n    padding: 2px 7px;\r\n\r\n    border-radius: 4px;\r\n\r\n    border: 1px solid #3B82F6;\r\n\r\n    background: transparent;\r\n    color: #3B82F6;\r\n\r\n    cursor: pointer;\r\n\r\n    transition: background 0.15s, color 0.15s;\r\n}\r\n\r\n.new-conv-sidebar-button:hover {\r\n    background: #3B82F6;\r\n    color: white;\r\n}\r\n\r\n.sidebar-loading,\r\n.sidebar-empty {\r\n    padding: 16px 10px;\r\n    font-size: 11px;\r\n    color: #999;\r\n    text-align: center;\r\n}\r\n\r\n.conversations-list {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 4px 0;\r\n\r\n    overflow-y: auto;\r\n    flex: 1;\r\n\r\n    scrollbar-width: thin;\r\n    scrollbar-color: rgba(0, 0, 0, 0.15) transparent;\r\n}\r\n\r\n.conversations-list::-webkit-scrollbar {\r\n    width: 3px;\r\n}\r\n\r\n.conversations-list::-webkit-scrollbar-track {\r\n    background: transparent;\r\n}\r\n\r\n.conversations-list::-webkit-scrollbar-thumb {\r\n    background: rgba(0, 0, 0, 0.15);\r\n    border-radius: 2px;\r\n}\r\n\r\n.conversation-item {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n\r\n    padding: 7px 10px;\r\n\r\n    cursor: pointer;\r\n\r\n    border-radius: 6px;\r\n    margin: 2px 4px;\r\n\r\n    font-size: 11px;\r\n    color: #444;\r\n\r\n    transition: background 0.15s;\r\n}\r\n\r\n.conversation-item:hover {\r\n    background: rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.conversation-item.active {\r\n    background: rgba(59, 130, 246, 0.1);\r\n    color: #2563EB;\r\n    font-weight: 600;\r\n}\r\n\r\n.conv-title {\r\n    flex: 1;\r\n\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n\r\n    margin-right: 4px;\r\n}\r\n\r\n.conv-actions {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 2px;\r\n\r\n    opacity: 0;\r\n    pointer-events: none;\r\n\r\n    transition: opacity 0.15s;\r\n}\r\n\r\n.conversation-item:hover .conv-actions,\r\n.conversation-item.active .conv-actions {\r\n    opacity: 1;\r\n    pointer-events: auto;\r\n}\r\n\r\n.conv-rename-button,\r\n.conv-delete-button {\r\n    background: transparent;\r\n    border: none;\r\n\r\n    cursor: pointer;\r\n\r\n    padding: 2px;\r\n\r\n    color: #bbb;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    border-radius: 3px;\r\n\r\n    transition: color 0.15s;\r\n}\r\n\r\n.conv-rename-button:hover {\r\n    color: #3B82F6;\r\n}\r\n\r\n.conv-delete-button:hover {\r\n    color: #ef4444;\r\n}\r\n\r\n.conv-rename-input {\r\n    flex: 1;\r\n\r\n    min-width: 0;\r\n\r\n    font-size: 11px;\r\n\r\n    padding: 2px 5px;\r\n\r\n    border: 1px solid #3B82F6;\r\n    border-radius: 3px;\r\n\r\n    outline: none;\r\n\r\n    background: white;\r\n\r\n    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\r\n}\r\n\r\n/* ==========================================================================\r\n   MAIN CHAT COLUMN\r\n   ========================================================================== */\r\n\r\n.chat-main {\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    flex: 1;\r\n    min-width: 0;\r\n\r\n    overflow: hidden;\r\n}\r\n\r\n/* ==========================================================================\r\n   MESSAGES\r\n   ========================================================================== */\r\n\r\n.messages-area {\r\n    flex: 1;\r\n\r\n    min-height: 0;\r\n\r\n    padding: 16px;\r\n\r\n    overflow-y: auto;\r\n\r\n    background: linear-gradient(180deg, #ffffff, #f9fafb);\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    gap: 12px;\r\n}\r\n\r\n.messages-area::-webkit-scrollbar {\r\n    width: 4px;\r\n}\r\n\r\n.messages-area::-webkit-scrollbar-track {\r\n    background: transparent;\r\n}\r\n\r\n.messages-area::-webkit-scrollbar-thumb {\r\n    background: #d1d5db;\r\n    border-radius: 2px;\r\n}\r\n\r\n/* ==========================================================================\r\n   WELCOME MESSAGE\r\n   ========================================================================== */\r\n\r\n.welcome-message {\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    flex: 1;\r\n\r\n    padding: 32px 16px;\r\n\r\n    text-align: center;\r\n}\r\n\r\n.welcome-icon {\r\n    width: 48px;\r\n    height: 48px;\r\n\r\n    background: rgba(59, 130, 246, 0.1);\r\n\r\n    border-radius: 50%;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.welcome-icon svg {\r\n    width: 24px;\r\n    height: 24px;\r\n    color: #3B82F6;\r\n}\r\n\r\n.welcome-message p {\r\n    color: #6b7280;\r\n    font-size: 14px;\r\n    margin: 0;\r\n}\r\n\r\n/* ==========================================================================\r\n   INPUT\r\n   ========================================================================== */\r\n\r\n.chat-input-area {\r\n    padding: 12px 16px;\r\n\r\n    border-top: 1px solid #e5e7eb;\r\n\r\n    background: white;\r\n\r\n    flex-shrink: 0;\r\n}\r\n\r\n.input-container {\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    gap: 8px;\r\n    width: 100%;\r\n}\r\n\r\n.message-input {\r\n    flex: 1;\r\n    min-width: 0;\r\n\r\n    padding: 10px 14px;\r\n\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 8px;\r\n\r\n    font-size: 14px;\r\n    font-family: inherit;\r\n\r\n    outline: none;\r\n\r\n    transition: border-color 0.2s;\r\n\r\n    resize: none;\r\n}\r\n\r\n.message-input:focus {\r\n    border-color: #3B82F6;\r\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.message-input:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n    background: #f9fafb;\r\n}\r\n\r\n.send-button {\r\n    background: #3B82F6;\r\n    color: white;\r\n\r\n    border: none;\r\n    border-radius: 8px;\r\n\r\n    padding: 10px 12px;\r\n\r\n    cursor: pointer;\r\n\r\n    flex-shrink: 0;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    transition:\r\n        background-color 0.2s,\r\n        transform 0.1s;\r\n}\r\n\r\n.send-button:hover:not(:disabled) {\r\n    background: #2563EB;\r\n}\r\n\r\n.send-button:active:not(:disabled) {\r\n    transform: scale(0.95);\r\n}\r\n\r\n.send-button:disabled {\r\n    opacity: 0.4;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.send-button svg {\r\n    width: 16px;\r\n    height: 16px;\r\n}\r\n\r\n/* ==========================================================================\r\n   ANIMATIONS\r\n   ========================================================================== */\r\n\r\n@keyframes slide-up {\r\n    from {\r\n        transform: translateY(100%);\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        transform: translateY(0);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n/* ==========================================================================\r\n   MOBILE\r\n   ========================================================================== */\r\n\r\n@media (max-width: 768px) {\r\n\r\n    .chat-panel {\r\n        right: 0;\r\n        bottom: 0;\r\n\r\n        width: 100vw;\r\n        height: 100vh;\r\n\r\n        border-radius: 0;\r\n    }\r\n\r\n    .chat-panel.sidebar-open {\r\n        width: 100vw;\r\n    }\r\n\r\n    .chat-panel.sidebar-open .conversations-sidebar {\r\n        width: 180px;\r\n        min-width: 180px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
